module.exports = __webpack_public_path__ + "img/icon_upload.b828c231.svg";